export default __webpack_public_path__ + "static/media/usc-ucla.75b2332a.png";